import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setLanguage } from '../../containers/App/actions';
import ReactFlagsSelect from 'react-flags-select';

const SelectLanguage = () => {
  const dispatch = useDispatch();
  const handleLanguage = useCallback(e => dispatch(setLanguage(e)), [dispatch]);

  return (
    <div className="form-group select-language">
      <ReactFlagsSelect
        onSelect={e => handleLanguage(e)}
        countries={['US', 'RS']}
        showOptionLabel={false}
        defaultCountry="RS"
        showSelectedLabel={false}
      />
    </div>
  );
};

export default SelectLanguage;
